import React from 'react';
import css from './Sections.module.css';
import { Button, InlineTextButton } from '../../../components';

function SectionHero({ intl, useHistoryPush }) {
  return (
    <div className={css.heroContainer}>
      <div className={css.heroContent}>
        <h1>{intl.formatMessage({ id: 'SectionHero.heading' })}</h1>
        <div className={css.heroActions}>
          <InlineTextButton onClick={() => useHistoryPush('SearchPage')}>
            {intl.formatMessage({ id: 'SectionHero.findProducts' })}
          </InlineTextButton>
          <InlineTextButton onClick={() => useHistoryPush('NewListingPage')}>
            {intl.formatMessage({ id: 'SectionHero.postListing' })}
          </InlineTextButton>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;